import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'description-box',
  templateUrl: './description-box.component.html',
  styleUrls: ['./description-box.component.scss']
})
export class DescriptionBoxComponent implements OnInit {
  @Input('description') description: string;
  constructor() { }

  ngOnInit() {
  }

}
